var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"series-tile grid-item image-tile tmp-img-aa"},[_c('img',{class:{zoomed:_vm.zoomed},attrs:{"src":_vm.eventObj},on:{"click":function($event){return _vm.zoomImg()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }